import { render, staticRenderFns } from "./AboutPhotos.vue?vue&type=template&id=7425386f&scoped=true&"
import script from "./AboutPhotos.vue?vue&type=script&lang=js&"
export * from "./AboutPhotos.vue?vue&type=script&lang=js&"
import style0 from "./AboutPhotos.vue?vue&type=style&index=0&id=7425386f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7425386f",
  null
  
)

export default component.exports